/* global femcare */

femcare.sampleCoupon.order = {
    $samples: $('.sample-coupon'),

    init () {
        if (this.$samples.length) {
            this.initFragmentListener();
            this.initOrderToggleHandlers();
            this.initUrlQueryListener();

        }
    },

    initOrderToggleHandlers () {
        this.$samples.find('.signpost-basic a').on('click', this.loadOrderForm.bind(this));

        // Close opened order on close button click.
        $('.sample-coupon__order').on(
            'click',
            '.sample-coupon__close, .sample-coupon-response__ok',
            (e) => {
                e.preventDefault();
                this.closeOrderForm($(e.currentTarget).closest('.sample-coupon__order'));
            }
        );
    },

    loadOrderForm (e) {
        e.preventDefault();

        const $button = $(e.currentTarget);
        const $sample = $button.closest('.sample-coupon');
        const $orderToOpen = $sample.find('.sample-coupon__order');

        // Close any other order that is opened before opening the new one.
        const $orderToClose = $('.sample-coupon__order')
            .not($orderToOpen)
            .filter(':parent');

        const requestInfo = { method: 'get', uri: $sample.data('ajax-uri') };

        if ($orderToClose.length) {
            this.closeOrderForm(
                $orderToClose,
                () => {
                    this.makeRequest(requestInfo, $orderToOpen);
                }
            ); 
        } else {
            this.makeRequest(requestInfo, $orderToOpen);
        }
    },

    async makeRequest (requestInfo, $order) {
        const data = requestInfo.method === 'post' ? $order.find('form').serialize() : null;
        let antiforgeryToken = '';

        const request = {
            type: requestInfo.method,
            url: requestInfo.uri,
            data,
            cache: false,
            success: (response) => {
                if (response.type === 'HTML') {
                    $order.html(response.content);
                    const $form = $order.find('form');
                    if ($form.length) {
                        this.initOrderForm($form);
                        femcare.form.protection.init();
                    }

                    $order.slideDown();
                    const scrollTop = $order.offset().top;

                    $('html, body').animate({ scrollTop }, 1000);
                } else if (response.type === 'Location') {
                    window.location = response.content;
                }
            }
        };

        if (requestInfo.method === 'post') {
            antiforgeryToken = await femcare.form.protection.provideCSRFToken();
            request.headers = {
                'X-Request-Verification-Token': antiforgeryToken
            };
        }

        $.ajax(request);
    },


    /**
     * Initialize coupon form.
     * @param {object} $form jQuery form object to be initialized
     */
    initOrderForm ($form) {
        const $order = $form.closest('.sample-coupon__order');
        const $sample = $order.closest('.sample-coupon');
        const title = $sample.find('.signpost-basic__headline').text();
        const body = $sample.find('.signpost-basic__body').html();

        $order
            .find('h3')
            .text(title)
            .after(body);

        if ($form.find('#dynamicRecaptcha').length) {
            femcare.form.recaptcha.initDynamicRecaptcha();
        }

        femcare.shared.inputs.initInputsForForm($form);
        femcare.form.validationInitialization.initFormValidation($form);
        femcare.form.phoneInput.init();
        femcare.tooltip.init();
        femcare.tracking.forms.sampleFormVisible($form);
    },

    /**
     * Close sample order.
     * @param {object} $orderToClose sample order to be closed.
     * @param {function} callback function to be called after close.
     */
    closeOrderForm ($orderToClose, callback) {
        $orderToClose.slideUp(300, () => {
            $orderToClose.empty();
            if (callback) {
                callback();
            }
        });
    },

    initFragmentListener () {
        const fragment = window.location.hash;

        if (fragment) {
            const $sample = $(fragment);

            if ($sample.length) {
                const isSampleUnavailable = !!$sample.find('.signpost-basic__call-to-action--unavailable').length;

                if (isSampleUnavailable) {
                    return;
                }

                const $orderToOpen = $sample.find('.sample-coupon__order');
                const requestInfo = { method: 'get', uri: $sample.data('ajax-uri') };

                this.makeRequest(requestInfo, $orderToOpen);
            }
        }
    },

    /**
     * If query variable is set / redirected back to coupon/sample page
     */
    initUrlQueryListener () {
        const id = this.getQueryVariable('cta') || false;
        if (id) {
            const $button = $('#' + id).find('.signpost-basic__call-to-action .btn');
            const $sample = $button.closest('.sample-coupon');
            const $order = $('#' + id).find('.sample-coupon__order');

            const requestInfo = { method: 'get', uri: $sample.data('ajax-uri') };

            this.makeRequest(requestInfo, $order);
        }
    },

    /**
     * Helper function to get a querystring value from the URL.
     * @param {string} variable - Querystring key to get the value from.
     * @returns {string|boolean}
     */
    getQueryVariable (variable) {
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        for (let index = 0; index < vars.length; index++) {
            const pair = vars[index].split('=');
            if (pair[0] === variable) {
                return pair[1];
            }
        }

        return false;
    }
};
